var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"date-range-container"},[_c('div',{staticClass:"date-selectors"},[_c('div',[_c('label',[_vm._v("From")]),_c('v-date-picker',_vm._b({key:_vm.value[0] ? _vm.value[0].value : 'startDate',attrs:{"is-required":""},on:{"input":function($event){return _vm.selectDate($event, true)}},scopedSlots:_vm._u([{key:"default",fn:function({ inputValue, inputEvents }){return [_c('input',_vm._g({attrs:{"data-test":"select filter start date","placeholder":"mm/dd/yy"},domProps:{"value":inputValue},on:{"input":function($event){return _vm.move($event)}}},inputEvents))]}}])},'v-date-picker',{
          popover: {
            visibility: 'hidden',
          },
          updateOnInput: false,
          value: _vm.value[0],
        },false))],1),_c('div',[_c('label',[_vm._v("To")]),_c('v-date-picker',_vm._b({key:_vm.value[1] ? _vm.value[1].value : 'endDate',attrs:{"is-required":""},on:{"input":_vm.selectDate},scopedSlots:_vm._u([{key:"default",fn:function({ inputValue, inputEvents }){return [_c('input',_vm._g({attrs:{"data-test":"select filter end date","placeholder":"mm/dd/yy"},domProps:{"value":inputValue},on:{"input":function($event){return _vm.move($event)}}},inputEvents))]}}])},'v-date-picker',{
          popover: {
            visibility: 'hidden',
          },
          updateOnInput: false,
          value: _vm.value[1],
        },false))],1)]),_c('v-date-picker',_vm._b({ref:"calendar",attrs:{"is-range":"","trim-weeks":""},on:{"input":function($event){return _vm.$emit('input', $event ? [$event.start, $event.end] : [])}}},'v-date-picker',{
      value: {
        start: _vm.value[0],
        end: _vm.value[1],
      },
    },false))],1)
}
var staticRenderFns = []

export { render, staticRenderFns }